import { useQuery } from '@tanstack/react-query'
import { getProducts } from '../../api/products/products'

export function useHasLightningDeals() {
  return useQuery<boolean>(
    ['has-lightning-deals'],
    async () => {
      const products = await getProducts()
      return products.some((p) => p.isLightningDeal)
    },
    {
      staleTime: 1_000 * 60 * 5,
      refetchInterval: 1_000 * 60 * 10,
    },
  )
}
